import Icon from "components/Icon"
import Overlay from "components/Overlay"
import { type MouseEvent, useCallback } from "react"

import CarouselView from "./CarouselView"
import {
  OverlayCloseButton,
  OverlayContent,
  OverlayViewport
} from "./zoomOverlay.styled"
import type { CarouselOverlayState } from "./zoomOverlay.types"

const CarouselZoomOverlay = ({
  carouselProps,
  closeButtonRef,
  isOpen,
  name,
  onClose
}: CarouselOverlayState) => {
  const handleViewportClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      if (event.target !== event.currentTarget) return
      onClose()
    },
    [onClose]
  )

  const handleContentClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      event.stopPropagation()
    },
    []
  )

  const handleCloseButtonClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onClose()
    },
    [onClose]
  )

  return (
    <Overlay isOpen={isOpen} name={name} onClose={onClose}>
      <OverlayViewport onClick={handleViewportClick}>
        <OverlayCloseButton
          aria-label="Close zoom overlay"
          onClick={handleCloseButtonClick}
          ref={closeButtonRef}
          type="button"
        >
          <Icon group="fa6" name="FaXmark" size="18px" />
        </OverlayCloseButton>

        <OverlayContent onClick={handleContentClick}>
          <CarouselView {...carouselProps} />
        </OverlayContent>
      </OverlayViewport>
    </Overlay>
  )
}

export default CarouselZoomOverlay
